import { BaseResponse } from '../../../../../../types/api/api.types';
import { SearchProspectsResponse } from '../../../../../../types/api/endpoints/prospect/directory.types';
import { PROSPECT_ENDPOINTS } from '../../../../../../utils/api/endpoints/prospectEndpoints';
import { UpdateProspectStatusQueryParams } from './DashboardProspectionsTable.types';

const UPDATE_PREFIX = '[updateProspectStatusQuery]';

export const UPDATE_PROSPECT_STATUS_QUERY_KEY = 'UPDATE_PROSPECT_STATUS';

export const updateProspectStatusQuery = async (params: UpdateProspectStatusQueryParams) => {
  console.log(UPDATE_PREFIX, `Updating prospect status...`);
  const response = await PROSPECT_ENDPOINTS.updateStatus(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(UPDATE_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(UPDATE_PREFIX, `Updated prospect status.`);
  return json as BaseResponse;
};

const SEARCH_PREFIX = '[searchProspectQuery]';

export const SEARCH_PROSPECT_STATUS_QUERY_KEY = 'SEARCH_PROSPECT';

export const searchProspectQuery = async (search: string) => {
  console.log(SEARCH_PREFIX, `Fetching search prospects...`);
  const response = await PROSPECT_ENDPOINTS.directory(search);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(SEARCH_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(SEARCH_PREFIX, `Fetched search prospects.`);
  return json as SearchProspectsResponse;
};

const SEND_EMAIL_PREFIX = '[sendEmailProspectQuery]';

export const SEND_EMAIL_PROSPECT_QUERY_KEY = 'SEND_EMAIL_PROSPECT';

export const sendEmailProspectQuery = async (prospectId: number) => {
  console.log(SEND_EMAIL_PREFIX, `Sending email to prospect ${prospectId}...`);
  const response = await PROSPECT_ENDPOINTS.sendEmail(prospectId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(SEND_EMAIL_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(SEND_EMAIL_PREFIX, `Sent email to prospect ${prospectId}.`);
  return json as BaseResponse;
};
